import {
    makeStyles,
    Menu,
    MenuItem,
    MenuList,
    type MenuListProps,
    MenuPopover,
    MenuTrigger,
    Overflow,
    OverflowItem,
    ToolbarButton,
    ToolbarGroup,
    type ToolbarGroupProps,
    useIsOverflowItemVisible,
    useOverflowMenu,
} from '@fluentui/react-components';
import { MoreHorizontalRegular } from '@fluentui/react-icons';
import type { JSX } from 'react';

const useToolbarGroupStyles = makeStyles({
    toolbarOverflowGroup: {
        display: 'flex',
        flexGrow: 1,
        flexWrap: 'nowrap',
        overflow: 'auto',
    },
});

const OverflowGroup = (props: { children: Required<ToolbarGroupProps>['children'] }) => (
    <Overflow>
        <ToolbarGroup className={useToolbarGroupStyles().toolbarOverflowGroup}>
            {props.children}
        </ToolbarGroup>
    </Overflow>
);

class OverflowGroupItem {
    readonly id: string;
    private readonly useItemProps: TUseOverflowItemProps;

    private readonly MenuItemVisible = () => <MenuItem {...this.useItemProps()} />;

    constructor(useItemProps: TUseOverflowItemProps) {
        this.id = getId();
        this.useItemProps = useItemProps;
    }

    readonly Button = (/*props: IOverflowItemProps*/) => (
        <OverflowItem id={this.id}>
            <ToolbarButton {...this.useItemProps()} />
        </OverflowItem>
    );

    readonly MenuItem = (/*props: IOverflowItemProps*/) =>
        !useIsOverflowItemVisible(this.id) && <this.MenuItemVisible />;
}

const getId = (length: number = 6) => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        result += characters[randomIndex];
    }
    return result;
};

type TUseOverflowItemProps = () => {
    'aria-label'?: string;
    children?: string;
    disabled?: boolean;
    icon?: JSX.Element;
    // id: string;
    onClick?: () => void;
    persistOnClick?: boolean;
};

const OverflowMenu = (props: { children: Required<MenuListProps>['children'] }) => {
    const overflowMenu = useOverflowMenu<HTMLButtonElement>();

    return (
        overflowMenu.isOverflowing && (
            <Menu inline={true}>
                <MenuTrigger disableButtonEnhancement={true}>
                    <ToolbarButton
                        aria-label="Aktionen"
                        // children={overflowCount}
                        icon={<MoreHorizontalRegular />}
                        ref={overflowMenu.ref}
                    />
                </MenuTrigger>

                <MenuPopover>
                    <MenuList>{props.children}</MenuList>
                </MenuPopover>
            </Menu>
        )
    );
};

export const ToolbarOverflowGroup = {
    Group: OverflowGroup,
    Item: OverflowGroupItem,
    Menu: OverflowMenu,
} as const;
